import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Popover } from "antd";
import CurrencyList from "./currencyList";
import "./style.css";

const CurrencyChoice = ({activeCurrency, onChangeCurrency, newDetail}) => {

  const [visible, setVisible] = useState(false);

  return (
    <Popover
      overlayClassName="shadowReinforce"
      arrowPointAtCenter
      getPopupContainer={trigger => trigger.parentNode}
      placement="bottom"
      visible={visible}
      onVisibleChange={() => {
        const currentVisible = !visible;
        setVisible(currentVisible);
        // quando visibile nascondo la scrollbar della pagina per rendere agevole lo scroll
        document.body.style.overflow = currentVisible ? "hidden" : "auto";
      }}
      title={null}
      content={<CurrencyList setVisible={setVisible} newDetail={newDetail} onChangeCurrency={onChangeCurrency} activeCurrency={activeCurrency} />} trigger="click">

      <FontAwesomeIcon
        icon={["far", "angle-down"]}
        style={{
          color: "#0090d1",
          fontSize: "14px",
          cursor: "pointer",
          margin: "0 10px"
        }}
      />

    </Popover>
  );
};

export default CurrencyChoice;